import classNames from 'classnames';
import { Button } from 'palette/Button';
import { BodyText } from 'palette/Typography';
import Form from '@common/Form/Form';
import Text from '@common/Form/Text';
import { useTranslation } from '@common/Hooks/useTranslation';
import { BEMBlock } from '@helpers/classnames';
import '../styles/GlobalSearchForm.scss';

interface GlobalSearchFormProps {
    className?: string;
    clearButtonLabel?: string;
    hasCloseButton?: boolean;
    inputRef?: React.RefObject<HTMLInputElement>;
    placeHolder: string;
    searchTerm?: string;
    theme?: string | string[];
    tabIndex?: number;
    onClearSearchClick?: () => void;
    onFocus?: () => void;
    onModalCloseClick?: () => void;
    onSearchInputChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit?: () => void;
}

function GlobalSearchForm({
    className,
    clearButtonLabel,
    hasCloseButton,
    inputRef,
    placeHolder,
    searchTerm,
    theme,
    tabIndex,
    onClearSearchClick,
    onFocus,
    onModalCloseClick,
    onSearchInputChange,
    onSubmit,
}: GlobalSearchFormProps) {
    const translate = useTranslation();
    const showClearButton = searchTerm && clearButtonLabel;
    const [block, BEMElement] = BEMBlock('global-search-form');

    return (
        <div className={classNames(block, className)}>
            <Form
                customClass={BEMElement('form')}
                onSubmit={onSubmit}
            >
                <Text
                    color="strong"
                    enterKeyHint="search"
                    forwardedRef={inputRef}
                    iconName="palette_search"
                    iconSize="medium"
                    placeholder={placeHolder}
                    tabIndex={tabIndex}
                    theme={theme}
                    type="search"
                    value={searchTerm}
                    weight="regular"
                    onChange={onSearchInputChange}
                    onFocus={onFocus}
                />
                {showClearButton && (
                    <Button
                        isTransparent
                        className={BEMElement('clear-button')}
                        theme="secondary"
                        onClick={onClearSearchClick}
                    >
                        <BodyText
                            color="attention"
                            level="1"
                        >
                            {clearButtonLabel}
                        </BodyText>
                    </Button>
                )}
            </Form>
            {hasCloseButton && (
                <Button
                    isTransparent
                    ariaLabel={translate('accessibility_searchbar_close_label')}
                    className={BEMElement('cancel-button')}
                    iconName="palette_close"
                    theme="secondary"
                    onClick={onModalCloseClick}
                />
            )}
        </div>
    );
}

export default GlobalSearchForm;
